import Vue from "vue";
import moment from "moment";
import 'moment-timezone';
import { startCase, toUpper } from "lodash";
import { display as displayStatus } from "@/helpers/statuses";
import { display as displayOperationStatus } from "@/helpers/operation-statuses";
import numeral from "numeral";

Vue.filter("toLocalDate", iso8601 => {

	let formatted = '';

	if (typeof iso8601 === 'string' && iso8601) {

		const utc = moment.utc(iso8601);

		if (utc.isValid()) {

			formatted = utc.local().format("DD-MMM-YYYY");
		}
	}

	return formatted;

});

Vue.filter("toLocalDateAndTime", iso8601 => {

	let formatted = '';

	if (typeof iso8601 === 'string' && iso8601) {

		const utc = moment.utc(iso8601);

		if (utc.isValid()) {

			formatted = utc.local().format("DD-MMM-YYYY HH:mm");
		}
	}

	return formatted;

});

Vue.filter("fromUnix", seconds => {

	let formatted = '';

	if (seconds) {

		const utc = moment(seconds, 'X');

		if (utc.isValid()) {

			formatted = utc.toISOString();
		}
	}

	return formatted;

});

/**
 * Represent file size in a human friendly format.
 * Adapted: https://stackoverflow.com/a/14919494
 */
Vue.filter("humanFileSize", bytes => {
	const si = true;
	const thresh = si ? 1000 : 1024;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
});

Vue.filter("uppercase", value => {
	if (!value) return "";
	return toUpper(value);
});

Vue.filter("ucwords", value => {
	if (!value) return "";
	return startCase(value);
});

Vue.filter("formatDate", (value, format = "YYYY-MM-DD") => {
	return moment(value).format(format);
});

Vue.filter("formatDateToTimezone", (value) => {
	return moment.utc(value).tz(moment.tz.guess()).format('DD-MMM-YYYY HH:mm')
});

Vue.filter("numberPriceFormatter", number => {
	if (!number) number = 0;
	return numeral(number).format("0,0.00");
	// var value = Math.round(number)
	// return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})

Vue.filter("numberPriceFormatterWithDollarSign", number => {

	if (!number) number = 0;

	return numeral(number).format("0,0.00");

	// return '$' + numeral(number).format("0,0.00");

	// var value = Math.round(number)

	// return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

})


Vue.filter("statusDisplay", status => {
	return displayStatus(status);
});

Vue.filter("operationStatusDisplay", status => {
	return displayOperationStatus(status);
});


// WEBPACK FOOTER //
// ./src/filters/filters.js